import routes from './routes.json'
import shared from './shared.json'
import error from './error.json'
import pages from './pages.json'
import legal from './legal.json'
import cookieConsent from './cookie-consent.js'

export default {
  routes,
  shared,
  error,
  pages,
  legal,
  cookieConsent
}
